import { forwardRef } from "react";
import { Text } from "../Text/Text.js";
import { TextSize, TextWeight } from "../Text/Text.types.js";
import { StyledNavItem } from "./NavItem.style.js";
import { NavItemProps } from "./NavItem.types.js";

export const NavItem = forwardRef<HTMLDivElement, NavItemProps>((props, ref) => {
    const { children, onClick, label, selected, disabled, appendElement, ...rest } = props;

    return (
        <StyledNavItem
            {...rest}
            ref={ref}
            role="menuitem"
            onClick={
                disabled
                    ? undefined
                    : (event) => {
                          onClick(label, event);
                      }
            }
            onKeyDown={
                disabled
                    ? undefined
                    : (event) => {
                          if (event.key === "Enter") {
                              onClick(label, event);
                          }
                      }
            }
            tabIndex={0}
            selected={selected}
            aria-disabled={disabled ? "true" : "false"}
            disabled={disabled}
        >
            {typeof children === "string" ? (
                <Text weight={TextWeight.BOLD} size={TextSize["X-SMALL"]}>
                    {children}
                </Text>
            ) : (
                children
            )}

            {appendElement}
        </StyledNavItem>
    );
});
